import { CommonModule }        from '@angular/common';
import { NgModule }            from '@angular/core';
import { PageBaseComponent }   from '@app/shared/bases/page-base/page-base.component';
import { StickyContentModule } from '@shared/content-sections/sticky-content/sticky-content.module';

@NgModule( {
	declarations: [
		PageBaseComponent
	],
	imports: [
		CommonModule,
		StickyContentModule
	],
	exports: [
		PageBaseComponent
	],
	providers: []
} )
export class PageBaseModule {}
